export const KPI_KINDS = ['$','#','%']; 
export const KPI_DIRECTIONS = [1, -1];
export const KPI_IMAGE_PARAMS = ["image", "picture", "photo"];
export const KPI_FORM_INPUT_TYPES =  ["text", "image", "number", "date", "checkbox", "picture", "link", "notification_settings"];
/**
 * @constant {["progressive", "anchor", "display"]}
 */
export const KPI_TYPES = ["progressive", "anchor", "display"];
export const MAX_WORKSPACE_KPIS = 10;
